<template>
  <ConversationSimulateRight />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
